"use client";

import { ErrorCardContent } from "#app/_ui/components/cards/ErrorCard";
import { PendingCardContent } from "#app/_ui/components/cards/PendingCard";
import { logError } from "#app/lib/logger";

import { ChecksDialogContent } from "./checks-dialog-content";
import { useCheckQuery } from "./checks-page.utils";

export function ChecksDialogDetail({ checkId }: { checkId: string }) {
  const { data, error, isError, isPending } = useCheckQuery(checkId);

  if (isPending) {
    return <PendingCardContent />;
  }

  if (isError) {
    logError(error);
    return <ErrorCardContent />;
  }

  return <ChecksDialogContent data={data} />;
}
